import { map } from 'rxjs/operators';
import { Observable } from 'rxjs';
import { Injectable, Injector } from '@angular/core';
import { Command, CommandBase } from '../../../core/model/command';
import { ICommandHandler } from '../../../core/service/command/command-handler-resolver.service';
import { tenantCommand } from '../../model/const/command';
import { ActionWindowService } from '../../../core/service/action-window.service';
import { MoveBalanceFormComponent } from '../../component/move-balance-form/move-balance-form';
import { NavigationService } from '../../../core/service/navigation.service';

@Injectable()
export class MoveBalanceCommandHandler implements ICommandHandler {
  constructor(
    private _actionService: ActionWindowService,
    private _navigation: NavigationService,
    private _injector: Injector
  ) {}

  canExecute(command: CommandBase): boolean {
    if (command instanceof Command) {
      return command.id === tenantCommand.moveBalance && command.context;
    }
    return false;
  }
  execute(command: CommandBase): Observable<void> {
    if (command instanceof Command) {
      return this._actionService.open(MoveBalanceFormComponent, this._injector, null, command.context).pipe(
        map(res => {
          this._navigation.reloadCurrentRoute();
        })
      );
    }
  }
}
